import React from 'react'
import { Provider, useDispatch, useSelector } from 'react-redux'
import { Button, CircularProgress, Tooltip } from '@mui/material'
import SatelliteAltIcon from '@mui/icons-material/SatelliteAlt'
import BaseMapControl from './BaseMapControl'
import { getMapToggleButtonStyles } from './mapToggleButtonStyles'
import { setSatelliteEnabled } from '../../../redux/slices/Map/map'

/**
 * Control para habilitar/deshabilitar capa satelital
 * Toggle simple: ON (100%) / OFF
 */
class SatelliteControl extends BaseMapControl {
  constructor(store, theme) {
    super({ className: 'satellite-control' })
    this.store = store
    this.theme = theme
  }

  _renderContent() {
    const SatelliteButton = () => {
      const dispatch = useDispatch()
      const satelliteEnabled = useSelector(state => state.mapState.satelliteEnabled)
      const satelliteLoading = useSelector(state => state.mapState.satelliteLoading)

      const handleToggle = () => {
        if (satelliteLoading) return
        dispatch(setSatelliteEnabled(!satelliteEnabled))
      }

      const buttonStyles = {
        ...getMapToggleButtonStyles(this.theme, satelliteEnabled),
        '&.Mui-disabled': {
          color: this.theme.palette.text.disabled,
          bgcolor: this.theme.palette.background.paper,
        },
      }

      const tooltipTitle = satelliteLoading
        ? 'Cargando vista satelital…'
        : satelliteEnabled
          ? 'Desactivar vista satelital'
          : 'Activar vista satelital'

      return (
        <Tooltip title={tooltipTitle} placement="right">
          {/* span necesario para que Tooltip funcione con Button disabled */}
          <span>
            <Button
              onClick={handleToggle}
              size="small"
              disabled={satelliteLoading}
              sx={buttonStyles}>
              {satelliteLoading ? (
                <CircularProgress size={12} thickness={5} color="inherit" />
              ) : (
                <SatelliteAltIcon fontSize="small" />
              )}
            </Button>
          </span>
        </Tooltip>
      )
    }

    this._root.render(
      <Provider store={this.store}>
        <SatelliteButton />
      </Provider>,
    )
  }
}

export default SatelliteControl
